<template>
	<div
		ref="container"
		class="slider-layout__container"
	>
		<div class="slider-layout__left-panel">
			<slider />
		</div>
		<div class="slider-layout__right-panel">
			<div class="slider-layout__content">
				<Header
					ref="header"
					class="slider-layout__header"
					:display-icon="headerDisplayIcon"
				/>
				<slot />
			</div>
			<Footer />
		</div>
	</div>
</template>

<script>
import Slider from '@/components/Slider';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default {
	name: 'SliderLayout',
	components: {
		Slider,
		Header,
		Footer,
	},
	props: {
		headerDisplayIcon: {
			type: Boolean,
			required: false,
			default: false,
		},

		minHeight: {
			type: [Number, String],
			required: false,
			default: 720,
		},
	},
	watch: {
		minHeight(value) {
			this.$refs.container.style.minHeight = `${value}px`;
		},
	},
	mounted() {
		this.$refs.container.style.minHeight = `${this.minHeight}px`;
	},
};
</script>

<style scoped lang="scss" src="./slider-layout.scss" />
